module.exports = __webpack_public_path__ + "img/wafe-logo.light.5d9d2c41.png";